/**
 * The BMW section of the Internal Backoffice (Internal Backoffice → BMW). Pages for the BMW fleet
 * integration live under /backoffice/bmw; add each new page's route name and path here.
 */
export const BMW_ROUTE_NAMES = {
  healthCheck: 'bmwHealthCheck',
  howItWorks: 'bmwHowItWorks',
  pagesOverview: 'bmwPagesOverview',
} as const;

export const BMW_BACKOFFICE_PATHS = {
  root: '/backoffice/bmw',
  healthCheck: '/backoffice/bmw/readiness-check',
  howItWorks: '/backoffice/bmw/how-it-works',
  pagesOverview: '/backoffice/bmw/pages',
} as const;

/** Diagrams of BMW How It Works: ryd-portal-guides serves them through rp-users (PortalDiagramFrame). */
export const BMW_DIAGRAM_SET = 'bmw';

export const BMW_DIAGRAMS = {
  healthCheckFlow: {
    id: 'process-diagram',
    name: 'bmw-health-check-flow',
    icon: 'fa-sitemap',
    title: 'The Process At A Glance',
    intro:
      'What happens, in order, when you open the Readiness Check or press Check Again. Nothing is changed.',
  },
  deltaCreate: {
    id: 'delta-create-diagram',
    name: 'bmw-delta-create',
    icon: 'fa-plus-circle',
    title: 'How A Missing Delta Sponsor Is Created',
    intro:
      'The only thing on the Readiness Check that writes. What is written, in which order, and what is left behind if a step fails.',
  },
} as const;
